import { useMatomo } from '@datapunt/matomo-tracker-react';
import 'moment/locale/de';
import 'moment/locale/pl';
import React from 'react';
import { toast, ToastContainer } from 'react-toastify';
import LanguageParamSync from '../../components/LanguageParamSync';
import ScrollTopButton from '../../components/ScrollTopButton';
import ScrollToTop from '../../components/ScrollToTop';
import Routes from '../__Routes';

/**
 * App Component
 * - Serves as the root component of the application.
 * - Integrates global features such as routing, toast notifications, and scroll behavior.
 * - Enables Matomo link tracking for analytics.
 *
 * Props:
 * - `error` (string): Error message to display as a toast notification.
 * - `success` (string): Success message to display as a toast notification.
 */
const App = ({ error, success }) => {
    if (error) toast.error(error);
    if (success) toast.success(success);

    const { enableLinkTracking } = useMatomo();
    enableLinkTracking();
    return (
        <>
            <LanguageParamSync />
            <ScrollToTop />
            <Routes />
            <ToastContainer position="top-center" />
            <ScrollTopButton />
        </>
    );
};

export default App;
